"use client";

import {
  isGoogleSignInAvailable,
  startGoogleSignIn,
} from "@/lib/social-auth";
import { reportSocialAuthFailure } from "@/lib/report-social-auth-failure";
import { useCallback, useState } from "react";

export const useGoogleSignIn = (locale: string) => {
  const [isPending, setIsPending] = useState(false);
  const isAvailable = isGoogleSignInAvailable();

  const start = useCallback(async () => {
    if (!isAvailable || isPending) return;

    setIsPending(true);
    try {
      await startGoogleSignIn({ locale });
    } catch (error) {
      setIsPending(false);
      reportSocialAuthFailure("start", error);
      throw error;
    }
  }, [isAvailable, isPending, locale]);

  return { isAvailable, isPending, start };
};
